import { ShiftCourierJson, ShiftStatusType } from 'const/ShiftConst';

// Filter a list of shifts having a status type
export const filterShiftsWithStatus = (
  list: ShiftCourierJson[],
  status: ShiftStatusType
) => list.filter(shift => shift.status === status);
